import {
  Component,
  input,
  OnDestroy,
  OnInit,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { DynamicFormComponent } from 'src/app/core/dynamic-form/dynamic-form.component';
import {
  DynamicFormOptions,
  FieldConfig,
  FieldTypeEnum,
} from 'src/app/core/dynamic-form/dynamicForm.interface';
import { EditHistoryData } from 'src/app/core/edit-history/edit-history';
import { ToastService } from 'src/app/core/toast/toast.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { environment } from 'src/environments/environment';
import { selectionButtonClass } from '../../gestione-missioni/form-missioni/form-missioni.component';
import {
  EnigmaDto,
  CreateEnigma,
  MultipleChoiceConfig,
  TrueFalseConfig,
  NumericAnswerConfig,
  AnswerTypes,
  ANSWER_TYPE_ICONS,
  ANSWER_TYPE_LABELS,
  AudioConfig,
  ImageQuizConfig,
} from '../enigmi-dto';
import { GestioneEnigmiService } from '../gestione-enigmi.service';
import { EditHistoryModule } from 'src/app/core/edit-history/edit-history.module';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { TablerIconComponent, provideTablerIcons } from 'angular-tabler-icons';
import {
  IconList,
  IconCheck,
  IconHash,
  IconPhoto,
  IconVolume2,
  IconX,
} from 'angular-tabler-icons/icons';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DynamicFormModule } from 'src/app/core/dynamic-form/dynamic-form.module';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { slideDownUp } from 'src/app/core/global-app-animations';
import { StorieEnigmiComponent } from '../../storie-enigmi/storie-enigmi.component';
import { GenericDD } from 'src/app/model/generic-data';
import { StepDto } from '../../gestione-step/step-dto';
import { GestioneStepService } from '../../gestione-step/gestione-step.service';
import { customBreadCrumbRequest } from 'src/app/core/bread-crumbs/bread-crumbs.component';

@Component({
  selector: 'app-form-enigmi',
  imports: [
    CommonModule,
    DynamicFormModule,
    EditHistoryModule,
    MatButtonModule,
    FormsModule,
    LeafletModule,
    TablerIconComponent,
    MatListModule,
    MatIconModule,
    NgxMaskDirective,
    StorieEnigmiComponent,
  ],
  providers: [
    provideNgxMask(),
    provideTablerIcons({
      IconList,
      IconCheck,
      IconHash,
      IconPhoto,
      IconVolume2,
      IconX,
    }),
  ],
  templateUrl: './form-enigmi.component.html',
  styleUrl: './form-enigmi.component.scss',
  animations: [slideDownUp],
})
export class FormEnigmiComponent implements OnInit, OnDestroy {
  @ViewChild('myForm') myForm!: DynamicFormComponent;
  @ViewChild('questionType') questionType!: TemplateRef<any>;

  idStep = input<string>('');
  internalStepId = signal<string>('');
  currentStep?: StepDto;

  selectedQuestionType: AnswerTypes = AnswerTypes.multiple;
  questionTypes = Object.values(AnswerTypes) as AnswerTypes[];
  questionTypeIcons = ANSWER_TYPE_ICONS;
  questionTypeLabels = ANSWER_TYPE_LABELS;

  //DATA FROM API, THE ONE THAT GETS CHANGED AND THE OG ONE
  //CHANGE THE TYPE TO THE ONE YOU NEED
  public object?: EnigmaDto;

  //configurations
  multipleChoiceConfig: MultipleChoiceConfig = {
    correctOptionIndex: -1,
    options: [],
  };
  truefalseConfig: TrueFalseConfig = { correctAnswer: true };
  numericConfig: NumericAnswerConfig = { correctNumber: '0' };

  optionInsertValue: string = '';
  //ID
  codice: string = '';

  buttonClass: string = selectionButtonClass;

  //FORM OPTIONS, DEFINED IN CONSTRUCTOR
  form2Opts: DynamicFormOptions;

  //FOR SHOWING OR HIDING FORM, USEFULL FOR REINITIALIZING
  ready: boolean = false;

  //FOR SHOWING CREATEDBY AND EDITEDBY
  editHistoryData: EditHistoryData | undefined;

  //FORM FIELDS
  regConfig2: FieldConfig[] = [];

  // enigmas list from mission
  currentEnigmas: EnigmaDto[] = [];
  currentDataForDD: GenericDD[] = [];

  //NO MEMORY LEAKS FIX
  private theEnd$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute, //IF YOU USE paramMap
    private router: Router,
    private toast: ToastService,
    private enigmaService: GestioneEnigmiService,
    private localStorageService: LocalStorageService,
    private stepService: GestioneStepService
  ) {
    this.form2Opts = {
      buttonAtBottom: true, //PUT THIS ALWAYS TO MAKE BUTTON STICK TO BOTTOM
      formType: 'add', //add, edit, view
    };
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  ngOnInit(): void {
    if (this.idStep()) {
      this.internalStepId.set(this.idStep());
    } else {
      this.internalStepId.set(this.route.snapshot.paramMap.get('id') || '');
    }

    this.form2Opts = {
      buttonAtBottom: true, //PUT THIS ALWAYS TO MAKE BUTTON STICK TO BOTTOM
      formType: 'add', //add, edit, view
      editOptions: {
        entityName: 'enigma', //for lockserver apis
        entityDisplayName: 'Enigma', //placeholder for messages
        deleteUrl: `${environment.apiUrl}/Enigmas`, //delete url
        deleteMessage: `Stai per eliminare l'enigma, procedere?`, //message on delete dialog
        deleteItem: '', //delete code/id depends, assign this when initializing form
        entityId: '', //id for lockserver apis
        isFem: false, //is fem or male?
        redirectUrl: `home/step/${this.idStep()}`, //url where it goes after delete
      },
      addOptions: {
        entityName: 'enigma',
        entityDisplayName: 'Enigma',
        isFem: false,
        redirectUrl: `home/step/${this.idStep()}`, //url where it goes when cancelling
      },
    };

    this.initializeForm();
    this.loadStepDetails(this.internalStepId());
  }

  goBackToStep() {
    const stepId = this.internalStepId();

    if (!stepId) {
      this.router.navigate(['home/missioni-esplorative']);
      return;
    }

    this.router.navigate(['home/step', stepId]);
  }

  loadStepDetails(stepId: string) {
    if (!stepId) return;

    this.stepService
      .read(stepId)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (step: StepDto) => {
          this.currentStep = step;

          const redirectUrl = `home/step/${step.id}`;

          if (this.form2Opts.editOptions) {
            this.form2Opts.editOptions.redirectUrl = redirectUrl;
          }

          if (this.form2Opts.addOptions) {
            this.form2Opts.addOptions.redirectUrl = redirectUrl;
          }
        },
        error: () => {},
      });
  }

  //based on route decides what form to show, adapt this logic if url contains more add or edit strings
  initializeForm() {
    if (this.router.url.includes('new')) {
      this.form2Opts.formType = 'add';
      this.localStorageService.setTitolo('Nuova Enigma');
      this.initializeFormFields();
    } else {
      this.form2Opts.formType = 'edit';
      this.initializeEditForm();
    }
  }

  getTheEnigmiByGame() {
    this.enigmaService
      .getAllByStep(this.internalStepId())
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (data: EnigmaDto[]) => {
          this.currentEnigmas = data;

          this.currentDataForDD = [];
          this.currentDataForDD.push({
            codice: 'Nessuna dipendenza',
            id: null,
          });
          for (let data of this.currentEnigmas) {
            let dataToPuh: GenericDD = {
              codice: data.name,
              id: data.id,
            };
            this.currentDataForDD.push(dataToPuh);
          }

          let i = this.regConfig2.findIndex((x) => x.name == 'enigmaParent');
          if (i > -1 && this.myForm != undefined) {
            this.regConfig2[i].data = this.currentDataForDD;
            this.regConfig2[i].value = this.object?.dependsOn;
            this.myForm.parsedFields[i] = _.cloneDeep(this.regConfig2[i]);
          }
        },
      });
  }

  initializeFormFields() {
    this.regConfig2 = [
      {
        type: FieldTypeEnum.input,
        name: 'name',
        label: 'Nome',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.name : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci un nome',
          },
        ],
      },
      {
        type: FieldTypeEnum.textarea,
        name: 'shortDescription',
        label: 'Breve descrizione',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.shortDescription : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una breve descrizione',
          },
        ],
      },
      {
        type: FieldTypeEnum.textarea,
        name: 'description',
        label: 'Descrizione',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.description : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una descrizione',
          },
        ],
      },
      {
        type: FieldTypeEnum.textarea,
        name: 'question',
        label: 'Domanda',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.question : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci la domanda',
          },
        ],
      },

      {
        type: FieldTypeEnum.numberInput,
        name: 'x',
        label: 'Coordinata X',
        isRequired: false,
        width: 'w-1/2',
        value: this.object ? this.object.x : undefined,
      },
      {
        type: FieldTypeEnum.numberInput,
        name: 'y',
        label: 'Coordinata Y',
        isRequired: false,
        width: 'w-1/2',
        value: this.object ? this.object.y : undefined,
      },
      {
        type: FieldTypeEnum.checkbox,
        name: 'formValid',
        value: this.form2Opts.formType == 'edit',
        hidden: true,
        validations: [
          {
            name: 'true',
            validator: Validators.requiredTrue,
            message: '',
          },
        ],
      },
      {
        type: FieldTypeEnum.select,
        name: 'enigmaParent',
        label: 'Enigma collegato',
        isRequired: false,
        width: 'w-full',
        value: this.object ? this.object.dependsOn : undefined,
        data: this.currentDataForDD,
      },
      {
        type: FieldTypeEnum.embed,
        name: 'questionType',
        width: 'w-full',
      },
    ];

    this.ready = true;

    setTimeout(() => {
      this.validateData();
    }, 100);

    this.getTheEnigmiByGame();
  }

  //make api call and get data for edit
  initializeEditForm() {
    this.codice = this.route.snapshot.paramMap.get('id') || '';

    this.enigmaService
      .read(this.codice)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: EnigmaDto) => {
          this.object = _.cloneDeep(response);
          this.internalStepId.set(response.stepFk);
          this.loadStepDetails(response.stepFk);

          if (response.type) this.selectedQuestionType = response.type;

          if (response.configurationJson)
            switch (this.selectedQuestionType) {
              case AnswerTypes.multiple:
                this.multipleChoiceConfig = JSON.parse(
                  response.configurationJson
                ) as MultipleChoiceConfig;
                break;

              case AnswerTypes.numeric:
                this.numericConfig = JSON.parse(
                  response.configurationJson
                ) as NumericAnswerConfig;
                break;
              case AnswerTypes.trueFalse:
                this.truefalseConfig = JSON.parse(
                  response.configurationJson
                ) as TrueFalseConfig;
                break;
              default:
                break;
              // case 'qr':
              //   this.myForm.form.controls['formValid'].setValue(true);
              //   break;
            }

          console.log(
            this.multipleChoiceConfig,
            this.numericConfig,
            this.truefalseConfig
          );

          this.localStorageService.setTitolo(
            `Modifica Enigma ${response.name}`
          );

          let req: customBreadCrumbRequest = {
            oldString: response.id,
            newString: response.name,
          }
          this.localStorageService.setCustomBreadCrumb(req);

          if (this.form2Opts.editOptions) {
            this.form2Opts.editOptions.deleteItem = '' + this.object.id;
            this.form2Opts.editOptions.entityId = this.object.id;
          }

          //run this method to display form
          this.initializeFormFields();
        },
        error: () => {},
      });
  }

  changeQuestionType(newValue: AnswerTypes) {
    this.selectedQuestionType = newValue;
    this.validateData();
  }

  //fires when submitting
  submit(event: any) {
    if (this.form2Opts.formType == 'add') {
      this.add(event);
    } else {
      this.edit(event);
    }
  }

  //edit submit
  edit(event: any) {
    console.log(event);
    let data: CreateEnigma = {
      name: event.name,
      description: event.description,
      shortDescription: event.shortDescription,
      question: event.question,
      stepFk: this.internalStepId(),
      configurationJson: this.getConfigTypeForSubmit(),
      type: this.selectedQuestionType,
      dependsOn: event.enigmaParent,
      x: this.toNullableNumber(event.x),
      y: this.toNullableNumber(event.y),
    };

    this.enigmaService
      .update(this.codice, data)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: EnigmaDto) => {
          this.toast.success('Modifiche salvate');
          this.initializeForm();
        },
        error: () => {},
      });
  }

  //add submit
  add(event: any) {
    console.log(event);
    let data: CreateEnigma = {
      name: event.name,
      description: event.description,
      shortDescription: event.shortDescription,
      question: event.question,
      stepFk: this.internalStepId(),
      configurationJson: this.getConfigTypeForSubmit(),
      type: this.selectedQuestionType,
      dependsOn: event.enigmaParent,
      x: this.toNullableNumber(event.x),
      y: this.toNullableNumber(event.y),
    };

    this.enigmaService
      .create(data)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: EnigmaDto) => {
          this.toast.success('Enigma creato');
          this.router.navigate(['home/enigmi', response.id]);
        },
        error: () => {},
      });
  }

  onFormChanges(event: any) {
    if (event.name != 'formValid') {
      this.validateData();
    }
  }

  validateData() {
    switch (this.selectedQuestionType) {
      case AnswerTypes.multiple:
        this.myForm.form.controls['formValid'].setValue(
          this.multipleChoiceConfig.options.length > 0 &&
            this.multipleChoiceConfig.correctOptionIndex != -1
        );
        break;
      case AnswerTypes.numeric:
        console.log(this.numericConfig.correctNumber);
        this.myForm.form.controls['formValid'].setValue(
          this.numericConfig.correctNumber.toString().length > 0
        );
        break;
      case AnswerTypes.trueFalse:
        this.myForm.form.controls['formValid'].setValue(true);
        break;
      // case 'qr':
      //   this.myForm.form.controls['formValid'].setValue(true);
      //   break;
    }
  }

  getConfigTypeForSubmit():
    | MultipleChoiceConfig
    | TrueFalseConfig
    | NumericAnswerConfig
    | ImageQuizConfig
    | AudioConfig {
    switch (this.selectedQuestionType) {
      case AnswerTypes.multiple:
        return this.multipleChoiceConfig;
      case AnswerTypes.numeric:
        this.numericConfig.correctNumber += '';
        return this.numericConfig;
      case AnswerTypes.trueFalse:
        return this.truefalseConfig;
      default:
        return this.truefalseConfig;
      // case 'qr':
      //   this.myForm.form.controls['formValid'].setValue(true);
      //   break;
    }
  }

  //converte il valore del campo coordinata in number oppure null (campo nullable)
  toNullableNumber(value: any): number | null {
    if (value === null || value === undefined || value === '') return null;
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }

  addChoice(name: string) {
    if (name.length > 0) {
      this.multipleChoiceConfig.options.push(name);
    }
    this.optionInsertValue = '';
  }

  deleteChoice(index: number) {
    this.multipleChoiceConfig.options.splice(index, 1);
  }
}
